module.exports = __webpack_public_path__ + "static/media/nucleo-icons.6836b93b.woff";